import { INCOME_STRUCTURE_BY_KVED_GROUP_SEPARATOR } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/incomeStructureByKved/constants.ts';
import type {
  TIncomeStructureByKvedCertificateDto,
  TIncomeStructureByKvedFormValues,
} from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/incomeStructureByKved/types.ts';
import { formatIncomeStructureByKvedDate } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/incomeStructureByKved/utils.ts';

const toNumber = (value: string): number | undefined => {
  const normalizedValue = value.replace(',', '.').trim();

  if (!normalizedValue) {
    return undefined;
  }

  const parsedValue = Number(normalizedValue);

  return Number.isFinite(parsedValue) ? parsedValue : undefined;
};

const isFilled = (value: string | null | undefined): boolean => Boolean(value?.trim());

export const serializeIncomeStructureByKvedCertificate = (
  values: TIncomeStructureByKvedFormValues
): TIncomeStructureByKvedCertificateDto => ({
  documentDate: formatIncomeStructureByKvedDate(values.documentDate),
  borrowerFullName: values.borrowerFullName.trim(),
  borrowerIdentifier: values.borrowerIdentifier.trim(),
  soleProprietor: values.soleProprietor,
  reportYear: Number(values.reportYear),
  incomes: values.incomes
    .filter((income) =>
      [income.kvedCode?.value, income.economicActivityGroup, income.incomeAmount].some(isFilled)
    )
    .map((income) => ({
      economicActivityGroup: [income.kvedCode?.value, income.economicActivityGroup.trim()]
        .filter(Boolean)
        .join(INCOME_STRUCTURE_BY_KVED_GROUP_SEPARATOR),
      incomeAmount: toNumber(income.incomeAmount) ?? 0,
    })),
});
